import React, { useEffect,  useRef,  useState }  from 'react'
import { useAuth } from '../../context/AuthContext';

function LeaveBalanceList() { 

    const { state } = useAuth();

    let user_data = state.user_data;

    return (
        <table className="table text-nowrap placeholder-glow">
            <thead className="table-primary">
                <tr>
                    <th scope="col">#</th>
                    {user_data.urole_permission==='*' ? (
                    <th scope="col">Team Member</th>
                    ) : ('' )} 
                    <th scope="col">Joining Date</th>
                    <th scope="col">Allocated</th>
                    <th scope="col">Balance</th>
                    <th scope="col">Taken</th>
                    <th scope="col">Pending</th>
                    <th scope="col">Allocated On</th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
                {[1,2,3,4,5,6,7,8].map((n) => (
                <tr>
                    <td><span className="placeholder col-1"></span></td>

                    {user_data.urole_permission==='*' ? (
                    <td><span className="placeholder col-3"></span></td>
                    ) : ('' )} 

                    <td><span className="placeholder col-3"></span></td>
                    <td><span className="placeholder col-3"></span></td>
                    <td><span className="placeholder col-3"></span></td>
                    <td><span className="placeholder col-3"></span></td>
                    <td><span className="placeholder col-3"></span></td>
                    <td><span className="placeholder col-3"></span></td>
                    <td>
                        <div className="hstack gap-2 fs-15">
                            <button href="javascript:void(0);" className="btn btn-icon btn-sm rounded-pill">
                                <span className="placeholder col-12"></span>
                            </button>
                        </div>
                    </td>
                </tr>
                )) }

            </tbody>
        </table>
    );
}  

export default LeaveBalanceList